import { connect } from "react-redux";

// Actions
import { createClient } from "../clientsActions";
import { completeAppOnboardingStep } from "../../AppOnboarding/appOnboardingActions";
// Component
import AddClient from "./AddClient";

// Store props to map with current state
const mapStateToProps = state => ({
  isLoading: state.client.isLoading,
  selectedOrganization: state.organization.selectedOrganization,
  createdClientId: state.client.createdClientId,
  duplicateEmail: state.client.duplicateEmail,
  appOnboardingSteps: state.appOnboarding?.steps,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  createClient: details => dispatch(createClient({ ...details })),
  completeAppOnboardingStep: (organizationId, stepId) =>
    dispatch(completeAppOnboardingStep(organizationId, stepId)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(AddClient);
